import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7694">
      <Navbar scrolled={scrolled} data-id="element-7695" />
      <main className="pt-24 pb-20" data-id="element-7696">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7697">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-7698">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-7699">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-7700">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-7701" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7702">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-7703">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-7704">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7705">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-7706">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7707">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7708">
                <li className="flex items-start" data-id="element-7709">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7710">
                    •
                  </span>
                  <span data-id="element-7711">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-7712">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7713">
                    •
                  </span>
                  <span data-id="element-7714">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-7715">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7716">
                    •
                  </span>
                  <span data-id="element-7717">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-7718">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7719">
                    •
                  </span>
                  <span data-id="element-7720">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-7721">
              <h2 className="text-xl font-semibold mb-2" data-id="element-7722">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-7723">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-7724">
                <div className="flex justify-between" data-id="element-7725">
                  <span data-id="element-7726">Monday - Friday:</span>
                  <span data-id="element-7727">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7728">
                  <span data-id="element-7729">Saturday:</span>
                  <span data-id="element-7730">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7731">
                  <span data-id="element-7732">Sunday:</span>
                  <span data-id="element-7733">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-7734" />
    </div>;
};